import { GetOrderErrorQuantityParams } from '../types/orderValidation.types';

export const getOrderErrorQuantity = ({ extra, key, formatMoney }: GetOrderErrorQuantityParams) => {
  const hasCurrencyInErrorMessage = extra?.type === 'CURRENCY' && extra?.[key];
  return hasCurrencyInErrorMessage ? formatMoney(extra?.[key] as number) : (extra?.[key] as number);
};
